<template>
  <el-dialog
    v-model="dialogVisible"
    width="800px"
    align-center
    :show-close="false"
    class="community-dialog"
    modal-class="community-dialog-mask"
  >
    <div class="dialog-header">
      <h2 class="dialog-title">加入短剧创作者交流社群</h2>
      <el-icon class="close-icon" @click="dialogVisible = false"><Close /></el-icon>
    </div>

    <div class="dialog-body">
      <div class="features-section">
        <div class="feature-item">
          <div class="feature-icon">
            <el-icon><VideoCamera /></el-icon>
          </div>
          <div class="feature-content">
            <div class="feature-title">
              <el-icon class="check-icon"><Check /></el-icon>
              <span>创作赋能</span>
            </div>
            <div class="feature-desc">创作交流+免费直播分享</div>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-icon">
            <el-icon><User /></el-icon>
          </div>
          <div class="feature-content">
            <div class="feature-title">
              <el-icon class="check-icon"><Check /></el-icon>
              <span>商单对接</span>
            </div>
            <div class="feature-desc">精准AI短剧商单合作接洽</div>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-icon">
            <el-icon><ChatLineRound /></el-icon>
          </div>
          <div class="feature-content">
            <div class="feature-title">
              <el-icon class="check-icon"><Check /></el-icon>
              <span>资源共享</span>
            </div>
            <div class="feature-desc">专属创作工具、素材、IP协作共享</div>
          </div>
        </div>
      </div>

      <div class="qrcode-section">
        <div class="qrcode-wrapper">
          <img :src="imageUrl" class="qrcode-image" />
        </div>
        <div class="qrcode-hint">扫码加入社群</div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import {
  Close,
  VideoCamera,
  User,
  ChatLineRound,
  Check,
} from "@element-plus/icons-vue";
import { EventBus, EVENTS } from "@/utils/eventBus";
import { ainewAiSettinginfo } from "@/api";

defineOptions({
  name: "CommunityDialog",
});

const dialogVisible = ref(false);
const imageUrl = ref("");

function getainewAiSettinginfo() {
  return ainewAiSettinginfo({}).then((res) => {
    if (res.code == 200) {
      imageUrl.value = res.data?.exchangeGroup || "";
    }
  });
}

function showDialog() {
  dialogVisible.value = true;
  // 打开时重新拉取，避免首屏配置未就绪导致二维码空白
  getainewAiSettinginfo();
}

onMounted(() => {
  getainewAiSettinginfo();
  EventBus.$on(EVENTS.SHOW_COMMUNITY_DIALOG, showDialog);
});

onBeforeUnmount(() => {
  EventBus.$off(EVENTS.SHOW_COMMUNITY_DIALOG, showDialog);
});
</script>

<style>
.community-dialog-mask {
  display: flex;
  align-items: center;
  justify-content: center;
}

.community-dialog {
  background-color: #1a1a1a;
  border-radius: 12px;
  padding: 0;
}

.community-dialog .el-dialog__header {
  display: none;
}

.community-dialog .el-dialog__body {
  padding: 0;
}
</style>

<style lang="scss" scoped>
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid #2d2d2d;

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    color: #fff;
  }

  .close-icon {
    font-size: 24px;
    color: #888;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #fff;
    }
  }
}

.dialog-body {
  display: flex;
  padding: 40px 32px;
  gap: 40px;
}

.features-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;

  .feature-icon {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: linear-gradient(135deg, #8bff8b 0%, #6ee06e 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .el-icon {
      font-size: 28px;
      color: #1a1a1a;
    }
  }

  .feature-content {
    flex: 1;
    padding-top: 4px;
  }

  .feature-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;

    .check-icon {
      font-size: 16px;
      color: #8bff8b;
      font-weight: bold;
    }

    span {
      font-size: 18px;
      font-weight: 500;
      color: #fff;
    }
  }

  .feature-desc {
    font-size: 14px;
    color: #888;
    line-height: 1.6;
  }
}

.qrcode-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .qrcode-wrapper {
    width: 260px;
    height: 260px;
    background-color: #fff;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 16px;

    .qrcode-image {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .qrcode-hint {
    font-size: 15px;
    color: #aaa;
    text-align: center;
  }
}
</style>
